"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IARefableIAGuard = exports.iaRefableIAJsonPropKeys = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const iaRefableIAJsonValidation = {
    Id: true,
    ArtNr: true,
    Montiert: true,
};
exports.iaRefableIAJsonPropKeys = echain_shared_modelling_1.UseableUtil.toPropKeys(iaRefableIAJsonValidation);
const iaRefableIAModelValidation = iaRefableIAJsonValidation;
/** Provide type guards for the different "useable" kinds. */
class IARefableIAGuard {
    /** check if it's an IA accessing a `IARefableIAModel` */
    static isRefableIA(ia) {
        return ia != null && echain_shared_modelling_1.UseableUtil.validate(ia.toJson(), iaRefableIAModelValidation);
    }
    /** check if it's the correct json to create a IARefableIAModel */
    static isRefableIAJson(json) {
        return json != null && echain_shared_modelling_1.UseableUtil.validate(json, iaRefableIAJsonValidation);
    }
    /** check if it's `IARefableIAModel` */
    static isRefableIAModel(model) {
        return model != null && echain_shared_modelling_1.UseableUtil.validate(model, iaRefableIAModelValidation);
    }
}
exports.IARefableIAGuard = IARefableIAGuard;
//# sourceMappingURL=IARefableIA.js.map